import { Layout, ConfigProvider, theme } from "antd";
import { Outlet } from "react-router-dom";
import Header from "../compoents/Header";
import Footer from "../compoents/Footer";
import { SETTHEME } from "../utils/configure";
import zhCN from "antd/locale/zh_CN";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
dayjs.locale("zh-cn");

const { Content } = Layout;

export default function MainLayout() {
  return (
    <ConfigProvider theme={SETTHEME} locale={zhCN}>
      <Layout>
        <Header />
        <Content>
          <div>
            <Outlet />
          </div>
        </Content>
        <Footer />
      </Layout>
    </ConfigProvider>
  );
}
